export default __webpack_public_path__ + "static/media/img1.2870a879.jpg";